import useAuthStore from '@/stores/authStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>((_to, _from, next) => {
  const authStore = useAuthStore();
  if (authStore.isAuth && !authStore.isDashboard && !authStore.isApproved) {
    return next({
      name: 'company.approved',
    });
  }

  return next();
});
